export const SELECTION_TYPES = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
} as const;

export type SelectionType = (typeof SELECTION_TYPES)[keyof typeof SELECTION_TYPES];

// Position constants
export const POSITIONS = {
  VERTICAL: {
    UP: 'up',
    DOWN: 'down',
  },
  HORIZONTAL: {
    LEFT: 'left',
    RIGHT: 'right',
  },
} as const;

export type VerticalPosition = (typeof POSITIONS.VERTICAL)[keyof typeof POSITIONS.VERTICAL];
export type HorizontalPosition = (typeof POSITIONS.HORIZONTAL)[keyof typeof POSITIONS.HORIZONTAL];

// Dropdown positioning and sizing constants
export const DROPDOWN_CONSTANTS = {
  // Dimensions
  MAX_HEIGHT: 300,
  MIN_WIDTH: 250,
  MOBILE_MIN_WIDTH: 200,
  MOBILE_BREAKPOINT: 480,
  VIEWPORT_HEIGHT_RATIO: 0.5,
  MAX_WIDTH_VW: 80,
  MAX_WIDTH_PX: 600,

  // Z-index
  Z_INDEX: 1000,

  // Icon dimensions
  ARROW_WIDTH: 12,
  ARROW_HEIGHT: 8,
  CLOSE_ICON_SIZE: 12,

  // SVG stroke width
  STROKE_WIDTH: 2,
} as const;

// SVG viewBox strings
export const SVG_VIEWBOXES = {
  DROPDOWN_ARROW: '0 0 12 8',
  CLOSE_ICON: '0 0 12 12',
} as const;

// UI Text constants
export const UI_TEXT = {
  NO_RESULTS: 'No results found',
  DEFAULT_PLACEHOLDER: 'Search options...',
} as const;

// DOM constants
export const DOM_CONSTANTS = {
  INITIAL_FOCUSED_INDEX: -1,
  TIMEOUT_DELAY: 0,
  SCROLL_BLOCK: 'nearest' as const,
  TAB_INDEX: 0,
} as const;

// Keyboard constants
export const KEYBOARD_KEYS = {
  ESCAPE: 'Escape',
  ENTER: 'Enter',
  SPACE: ' ',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
} as const;
